// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yFSs","textarea":"styles_textarea__1PqzZ"};